import React, { useState, useEffect } from 'react';
import Button from '@ingka/button';
import { Select, Option } from '@ingka/select';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'Store/store';
import { manualValidate } from 'Action/manualValidateAction';
import { masterDataManual } from 'Action/manualDropDownAction';
import { MANUAL_SUPPLIER_FETCH } from 'Action/types';
import FormField from '@ingka/form-field';
import InputField from '@ingka/input-field';
import Accordion, { AccordionItem } from '@ingka/accordion';
import TextArea from '@ingka/text-area';
import DatePickerComponent from 'pages/DatePickerComponent/datePickerComponent';
import './supplierDetails.scss';

const SupplierDetails = (props: any) => {
  const {
    supplierRows,
    setSupplierRows,
    countryActivity,
    setCountryActivity,
    operatorRows,
    setOperatorRows,
    setIsFilingImport,
    setIsValidate,
  } = props;
  const [referenceNumberValidate, setReferenceNumberValidate] = useState(false);
  const [validateVerification, setValidateVerification] = useState(false);
  const [selectedActivityType, setSelectedActivityType] = useState('');
  const [validationMessageColor, setValidationMessageColor] = useState('');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedSupplier, setselectedSupplier] = useState<string>('');
  // const [isValidate, setIsValidate] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');
  const [referenceNumber, setReferenceNumber] = useState(false);

  const handleActivityTypeChange = (event) => {
    setSelectedActivityType(event.target.value);
  };
  const dispatch = useDispatch<AppDispatch>();
  const { masterData } = useSelector((state: RootState) => state.dropDownMasterData);

  const handleSupplierChange = (index: number, field: any, value: any, event: any) => {
    if (field === 'ddsFilingDate' && value instanceof Date) {
      value = value.toISOString();
    }

    const newSupplierRows = supplierRows.map((row: any, i: any) =>
      i === index ? { ...row, [field]: value } : row
    );

    const updatedRow = newSupplierRows[index];
    const refLength = updatedRow.ddsReferenceNumber?.length || 0;
    const verLength = updatedRow.ddsVerificationNumber?.length || 0;

    setReferenceNumberValidate(refLength > 14);
    setValidateVerification(verLength > 8);
    setReferenceNumber(refLength === 14 && verLength === 8);

    setSupplierRows(newSupplierRows);
  };
  const handleCountryOfActivity = (index: number, field: any, value: any, event: any | null) => {
    const newCountryActivity = countryActivity.map((row: any, i: any) =>
      i === index ? { ...row, [field]: value } : row
    );
    const countryOfActivity = newCountryActivity[index].countryOfActivity;
    const borderCrossCountry = newCountryActivity[index].borderCrossCountry;
    setCountryActivity(newCountryActivity);
  };
  const handleOperator = (index: number, field: any, value: any, event: any | null) => {
    const newOperator = operatorRows.map((row: any, i: any) =>
      i === index ? { ...row, [field]: value } : row
    );
    setOperatorRows(newOperator);
  };

  const handleReset = () => {
    window.location.reload();
  };

  useEffect(() => {
    dispatch(masterDataManual());
  }, []);

  const payload = {
    ddsReferenceNumber: supplierRows[0].ddsReferenceNumber,
    ddsVerificationNumber: supplierRows[0].ddsVerificationNumber,
    ddsActivityType: supplierRows[0].ddsActivityType,
  };
  const handleValidateClick = async () => {
    try {
      const response = await dispatch(manualValidate(payload, MANUAL_SUPPLIER_FETCH));
      if (response && response?.status === 200) {
        setIsFilingImport(true);
        setIsValidate(true);
        setValidationMessage('Validated Successfully');
        setValidationMessageColor('green');
      } else if (response && response.status === 400) {
        setIsFilingImport(false);
        setIsValidate(false);
        const errorMessage =
          typeof response.data === 'string'
            ? response.data
            : response.data?.message || 'Validation failed';
        setValidationMessage(errorMessage);
        setValidationMessageColor('red');
      } else {
        setIsFilingImport(false);
        setIsValidate(false);
        setValidationMessage('Validation failed: Unknown error');
      }
    } catch (error) {
      setValidationMessage('Not Valid DDS');
      setValidationMessageColor('red');
    }
  };

  return (
    <div>
      {supplierRows.map((row: any, index: number) => (
        <React.Fragment key={`supplier-${index}`}>
          <div className="supplier-name">
            <Select
              className="supplier-div"
              id="supplierId"
              label="Supplier Name"
              value={row.supplierId}
              onChange={(e: any) => handleSupplierChange(index, 'supplierId', e.target.value, e)}
            >
              {masterData?.supplierMaster &&
                masterData?.supplierMaster.map((data: any) => (
                  <Option
                    key={data.supplierId + index}
                    value={data.supplierId}
                    name={data.supplierName}
                  />
                ))}
            </Select>
          </div>
          <div className="supplier-tab" key={index} style={{ display: 'flex', gap: 16 }}>
            <FormField
              characterLimit={14}
              fieldHelper={{
                id: 'helper-msg-id',
              }}
              shouldValidate={referenceNumberValidate}
              valid={
                row.ddsReferenceNumber &&
                (row.ddsReferenceNumber.length >= 14 || !/^\d+$/.test(row.ddsReferenceNumber))
                  ? 'error'
                  : false
              }
              validation={{
                id: 'error-msg-id',
                msg: 'Enter valid reference number',
                type: 'error',
              }}
            >
              <InputField
                label="DDS Reference Number"
                iconPosition="leading"
                id={`dds-ref-${index}`}
                type="number"
                style={{ marginRight: 10 }}
                value={row.ddsReferenceNumber || ''}
                onChange={(e) =>
                  handleSupplierChange(index, 'ddsReferenceNumber', e.target.value, e)
                }
                // readOnly={props.isFilingImport}
              />
            </FormField>
            <FormField
              characterLimit={8}
              fieldHelper={{
                id: 'helper-id',
              }}
              shouldValidate={validateVerification}
              valid={
                row.ddsVerificationNumber &&
                (row.ddsVerificationNumber.length >= 8 || !/^\d+$/.test(row.ddsVerificationNumber))
                  ? 'error'
                  : false
              }
              validation={{
                id: 'error-msg-id',
                msg: 'DDS Number Should Be 13 Digits',
                type: 'error',
              }}
            >
              <InputField
                style={{ marginRight: 10 }}
                label={index === 0 ? <>DDS Verification Number</> : ''}
                required={row.ddsReferenceNumber}
                iconPosition="leading"
                id={`dds-ver-${index}`}
                type="number"
                value={row.ddsVerificationNumber || ''}
                onChange={(e) =>
                  handleSupplierChange(index, 'ddsVerificationNumber', e.target.value, e)
                }
                // readOnly={props.isFilingImport}
              />
            </FormField>
            <Select
              id={`activitytype-${index}`}
              label="Activity Type"
              value={row.ddsActivityType}
              onChange={(e) => handleSupplierChange(index, 'ddsActivityType', e.target.value, e)}
              style={{ width: 'auto' }}
            >
              <Option value="EXPORT" name="EXPORT" />
              <Option value="IMPORT" name="IMPORT" />
              <Option value="TRADE" name="TRADE" />
              <Option value="DOMESTIC" name="DOMESTIC" />
            </Select>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <DatePickerComponent
                heading="DDS filing date"
                selectedDate={row.ddsFilingDate ? new Date(row.ddsFilingDate) : null}
                onChange={(formattedDate) =>
                  handleSupplierChange(index, 'ddsFilingDate', formattedDate, '')
                }
                format="iso"
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ height: 48 }}>
                <Button
                  style={{ marginTop: 8 }}
                  iconPosition="leading"
                  key="validate"
                  size="xsmall"
                  onClick={handleValidateClick}
                  type="emphasised"
                  disabled={props.isFilingImport || !referenceNumber}
                >
                  Validate
                </Button>
                <div style={{ height: '20px', display: 'flex', alignItems: 'center' }}>
                  {validationMessage && (
                    <div style={{ color: validationMessageColor }}>{validationMessage}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              gap: 16,
              marginTop: 8,
              marginBottom: 8,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button size="small" type="emphasised" onClick={props.handleFilingImport}>
              File Without DDS
            </Button>
            <Button
              iconPosition="trailing"
              key="reset"
              size="small"
              type="emphasised"
              onClick={handleReset}
            >
              Reset
            </Button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {countryActivity.map((row: any, index: number) => (
              <div key={index} style={{ display: 'flex', flexDirection: 'row', gap: 16 }}>
                <Select
                  id={`countryId-${index}`}
                  label="Country of Activity"
                  value={row.countryOfActivity}
                  style={{ maxHeight: 100 }}
                  onChange={(e) =>
                    handleCountryOfActivity(index, 'countryOfActivity', e.target.value, e)
                  }
                >
                  {masterData?.countryMaster &&
                    masterData.countryMaster.map((data) => (
                      <Option
                        key={data.countryCode + 'list2'}
                        value={data.countryName}
                        name={data.countryName}
                      />
                    ))}
                </Select>
                <Select
                  id={`countryId-${index}`}
                  label="borderCross Country"
                  value={row.borderCrossCountry}
                  style={{ maxHeight: 100 }}
                  onChange={(e) =>
                    handleCountryOfActivity(index, 'borderCrossCountry', e.target.value, e)
                  }
                >
                  {masterData?.countryMaster &&
                    masterData.countryMaster.map((data) => (
                      <Option
                        key={data.countryCode}
                        value={data.countryName}
                        name={data.countryName}
                      />
                    ))}
                </Select>
              </div>
            ))}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: 5,
                justifyContent: 'center',
              }}
            ></div>
            <Accordion>
              <AccordionItem title="Operator" id="Operator" key={index} open>
                {operatorRows.map((row: any, index: number) => (
                  <>
                    <div className="dds-tabs" key={index}>
                      <Select
                        className="operator-div"
                        id="Identifier"
                        label="Identifier"
                        value={row.operatorIdentifier}
                        onChange={(e: any) =>
                          handleOperator(index, 'operatorIdentifier', e.target.value, e)
                        }
                      >
                        <Option value="EORI" name="EORI" />
                        <Option value="VAT" name="VAT" />
                      </Select>
                      <InputField
                        style={{ marginRight: 10 }}
                        iconPosition="leading"
                        id={`article-number-${index}`}
                        type="text"
                        value={row.operatorValue || ''}
                        onChange={(e) => handleOperator(index, 'operatorValue', e.target.value, e)}
                        label="Value"
                      />
                    </div>
                    <div className="dds-tabs" key={index}>
                      <InputField
                        style={{ marginRight: 10 }}
                        iconPosition="leading"
                        id={`article-number-${index}`}
                        type="text"
                        value={row.operatorName || ''}
                        onChange={(e) => handleOperator(index, 'operatorName', e.target.value, e)}
                        label="Name"
                      />
                      <Select
                        id={`countryId-${index}`}
                        label="Country"
                        value={row.operatorCountry}
                        style={{ maxHeight: 100 }}
                        onChange={(e) =>
                          handleOperator(index, 'operatorCountry', e.target.value, e)
                        }
                      >
                        {masterData?.countryMaster &&
                          masterData.countryMaster.map((data) => (
                            <Option
                              key={data.countryName}
                              value={data.countryName}
                              name={data.countryName}
                            />
                          ))}
                      </Select>
                      <TextArea
                        id={`address-${index}`}
                        label="Address"
                        placeholder="Address"
                        value={row.operatorAddress}
                        onChange={(e) =>
                          handleOperator(index, 'operatorAddress', e.target.value, e)
                        }
                      />
                    </div>
                  </>
                ))}
              </AccordionItem>
            </Accordion>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default SupplierDetails;
